import axios from "axios";
import { config } from "../../utils/axiosconfig";
import { base_url } from "../../utils/baseUrl";
import axiosInstance from "../../utils/axiosconfig";

// const login = async (user) => {
//   const response = await axios.post(`${base_url}admin/login`, user);
//   if (response.data) {
//     localStorage.setItem("user", JSON.stringify(response.data));
//   }
//   return response.data;
// };

const login = async (userData) => {
  const response = await axiosInstance.post("admin/login", {
    email: userData.email?.trim().toLowerCase(),
    password: userData.password,
  });
  if (response.data) {
    localStorage.setItem("user", JSON.stringify(response.data));
  }
  return response.data;
};

// const getOrders = async () => {
//   const response = await axios.get(`${base_url}order/orders`, config);

//   return response.data;
// };
// const getOrder = async (id) => {
//   const response = await axios.get(
//     `${base_url}order/${id}`,
//     "",
//     config
//   );

//   return response.data;
// };

const getOrders = async () => {
  const response = await axiosInstance.get("order/orders");
  return response.data;
};

const getOrder = async (id) => {
  const response = await axiosInstance.get(`order/${id}`);
  return response.data;
};

// const getProfile = async (adminId) => {
//   const response = await axios.get(`${base_url}admin/profile/${adminId}`, config);
//   return response.data;
// };

const getProfile = async (adminId) => {
  console.log("Calling API with adminId:", adminId);
  const response = await axiosInstance.get(`${base_url}admin/profile/${adminId}`, config);
  console.log("API Response:", response.data);
  return response.data;
};

const authService = {
  login,
  getOrders,
  getOrder,
  getProfile
};

export default authService;
